import { Drawer } from 'components';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { ReactNode, useRef } from 'react';

const SaveSearchFiltersGroupDrawer: React.FC<{ children: ReactNode; onClose: () => void; active: boolean }> = ({
  children,
  onClose,
  active,
}) => {
  const drawerRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(drawerRef, onClose);
  return (
    <div ref={drawerRef}>
      <Drawer isActive={active} onClose={onClose}>
        {children}
      </Drawer>
    </div>
  );
};

//default needed for lazyLoading
export default SaveSearchFiltersGroupDrawer;
